import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/account/_auth/photo")({
  beforeLoad: () => {
    throw redirect({
      to: "/account/customerinfo",
      replace: true
    });
  }
});
